// extracted by mini-css-extract-plugin
export default {"background":"styles_background__G-K2j","gradient":"styles_gradient__NUw7t","row":"styles_row__02f+t","rows":"styles_rows__v9BDO"};